import { render } from "./DevTool.vue?vue&type=template&id=4e33539f&scoped=true"
import script from "./DevTool.vue?vue&type=script&lang=js"
export * from "./DevTool.vue?vue&type=script&lang=js"

import "./DevTool.vue?vue&type=style&index=0&id=4e33539f&scoped=true&lang=css"
import "./DevTool.vue?vue&type=style&index=1&id=4e33539f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e33539f"]])

export default __exports__